document.addEventListener("alpine:init", () => {
    Alpine.data("clientsGrid", () => ({
        currentFilters: { search: "" },
        searchValue: null,
        searchForm: null,
        isLoading: false,
        postGrid: null,
        filtering: false,
        init() {
            this.getCurrentFilters();

            this.searchForm = this.$refs.searchContainer;

            if (this.searchForm) {
                this.eventListeners();
            }
        },
        searchDebounce() {
            this.currentFilters.search = this.$refs.searchField.value;

            this.filtering = true;
            this.actioned = true;
            this.toggleFilter();
        },
        eventListeners() {
            this.searchForm.addEventListener("submit", (e) => {
                e.preventDefault();
                if (this.$refs.searchField.value.length) {
                    this.currentFilters.search = this.$refs.searchField.value;
                }
                this.filtering = true;
                this.actioned = true;
                this.toggleFilter();
            });
        },
        /**
         * loadMore
         *
         * Description: Loads the next page of posts below the current set of posts.
         * @return void
         *
         */
        loadMore() {
            // Get the post grid container and the data selector for the post grid.
            const postGrid = this.$root.querySelector(
                "[data-pegasus-filterable]"
            );
            const dataSelector =
                '[data-pegasus-filterable="' +
                postGrid.dataset.pegasusFilterable +
                '"]';

            // Get the url for the next page of posts. This is taken from the href of the load more button.
            const href = this.$el.getAttribute("href");

            // Get the container and elements to be loaded from the next page.
            const container = [dataSelector];
            const elements = [
                "[data-pegasus-single-card]",
                ".Post__Grid-next-page",
            ];

            // Only allow the load more button to be clicked whilst we're not waiting for a response.
            if (!this.isLoading) {
                this.isLoading = true;

                // Run the loadMoreContent function from pegasus.
                pegasus.loadMoreContent(href, container, elements, {}, () => {
                    this.isLoading = false;

                    // Remove the load more button from the original page,
                    // keeping only the one that comes back from the request.
                    this.$el.parentElement.remove();
                });
            }
        },

        /**
         * fetchPage
         *
         * Description: Gets the requested page of posts based on the
         * link selected in the pagination.
         *
         * @return void
         */
        fetchPage(href = null) {
            // Get the post grid container and the data selector for the post grid.
            const postGrid = this.$root.querySelector(
                "[data-pegasus-filterable]"
            );
            const elements = [
                'data-pegasus-filterable="' +
                    postGrid.dataset.pegasusFilterable +
                    '"',
            ];

            // Only allow a request to happen whilst we're not waiting for a response.
            if (!this.isLoading) {
                this.isLoading = true;

                // Run the ajaxContent function from pegasus.
                pegasus.ajaxContent(href, elements, {}, () => {
                    this.isLoading = false;

                    // Update the url with the current filters.
                    history.pushState("", "", href);

                    pegasus.scroll(postGrid);

                    // If the post grid items open in modals make sure to re-initialise them.
                    if (typeof window.modal !== "undefined") {
                        window.modal.init();
                    }
                });
            }
        },
        buildURL() {
            let url =
                window.location.protocol +
                "//" +
                window.location.hostname +
                window.location.pathname +
                "?";
            let i = 1;
            for (const [key, value] of Object.entries(this.currentFilters)) {
                url += `${key}=${value}`;
                if (i < Object.keys(this.currentFilters).length) {
                    url += "&";
                }
                i++;
            }

            return url;
        },

        toggleFilter(taxonomy, term, multiple = true) {
            if (typeof this.currentFilters[taxonomy] === "undefined") {
                this.currentFilters[taxonomy] = term;
                this.fetchContent();
                return;
            }

            if (this.currentFilters[taxonomy].length) {
                if (this.currentFilters[taxonomy].includes(term)) {
                    this.currentFilters[taxonomy] = this.removeFilter(
                        taxonomy,
                        term
                    );
                    if (!this.currentFilters[taxonomy].length) {
                        delete this.currentFilters[taxonomy];
                    }
                } else {
                    if (multiple) {
                        this.currentFilters[taxonomy] += "," + term;
                    } else {
                        this.currentFilters[taxonomy] = term;
                    }
                }
            } else {
                this.currentFilters[taxonomy] = term;
            }

            this.fetchContent();
        },
        clearFilters() {
            this.currentFilters = { search: "" };
            this.fetchContent();
            this.filtering = false;
        },
        removeFilter(filter, value) {
            const filterValue = this.currentFilters[filter];
            const filterValueArray = filterValue.split(",");

            for (let i = 0; i < filterValueArray.length; i++) {
                if (filterValueArray[i] === value) {
                    filterValueArray.splice(i, 1);
                }
            }

            return filterValueArray.toString();
        },
        clearFilter(filter) {
            if (typeof this.currentFilters[filter] === "undefined") {
                return;
            }

            if (this.currentFilters[filter].length) {
                delete this.currentFilters[filter];
            }

            this.fetchContent();
        },
        fetchContent() {
            const elements = ["data-pegasus-filterable"];

            this.isLoading = true;

            pegasus.ajaxContent(this.buildURL(), elements, {}, () => {
                this.isLoading = false;
                if (Object.keys(this.currentFilters).length > 1) {
                    this.filtering = true;
                }
                this.items = document.querySelectorAll(
                    "[data-pegasus-single-card]"
                ).length;
                window?.allModals()?.init();
            });
        },
        getCurrentFilters() {
            const url = new URL(window.location.href),
                params = new URLSearchParams(url.search);

            for (const [key, value] of params.entries()) {
                this.currentFilters[key] = value;
            }

            if (Object.keys(this.currentFilters).length > 1) {
                //this.removeOtherPostGrids();
                this.filtering = true;
            }
        },
    }));
});
